import * as React from 'react';
import { useState } from 'react';
import { translate } from '@js/common/helpers';
import { useNotifyMe } from '../hooks/useNotifyMe';
export function NotifyMeButton(_a) {
    var slug = _a.slug, userEmail = _a.userEmail;
    var _b = useNotifyMe(slug, userEmail), status = _b.status, subscribed = _b.subscribed, toggle = _b.toggle;
    var _c = useState(false), hovered = _c[0], setHovered = _c[1];
    function getLabel() {
        if (status === 'pending') {
            return translate('calendar.notify_me_pending');
        }
        if (status === 'error') {
            return translate('calendar.notify_me_error');
        }
        if (!subscribed) {
            return translate('calendar.notify_me');
        }
        if (hovered) {
            return translate('calendar.notify_me_cancel');
        }
        return "\u2713 " + translate('calendar.notify_me_done');
    }
    return (React.createElement("button", { type: "button", className: "btn-secondary show-card-notify show-card-notify--" + status, onClick: toggle, onMouseEnter: function () { return setHovered(true); }, onMouseLeave: function () { return setHovered(false); }, onFocus: function () { return setHovered(true); }, onBlur: function () { return setHovered(false); }, disabled: status === 'pending' }, getLabel()));
}
